const state = {
  plainsuppliers: [],
  suppliers: [],
  supplier: {},
  getSupplierLoading: false
};

export default {
  namespaced: true,
  state,
  mutations: {
    setSuppliers(state, suppliers) {
      state.suppliers = suppliers;
    },
    setPlainSuppliers(state, suppliers) {
      state.plainsuppliers = suppliers;
    },
    setSupplier(state, supplier) {
      state.supplier = supplier;
    },
    setGetSupplierLoading(state, loading) {
      state.getSupplierLoading = loading;
    }
  },
  actions: {
    fetchSuppliers({ commit, rootState }, payload) {
      const { dontPaginate, filter, page, paginationcount } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        commit('SET_LOADING', true, { root: true });
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/supplier', {
              params: { page: page, filter: filter, paginationcount: paginationcount }
            })
            .then(response => {
              commit('setSuppliers', response.data);
            })
            .catch(error => {
              if (error.response.status == 403) {
                commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {
              commit('SET_LOADING', false, { root: true });
            });
        }
        return axios
          .get('api/v1/supplier', { params: { page: page, paginationcount: paginationcount } })
          .then(response => {
            commit('setSuppliers', response.data);
          })
          .finally(() => {
            commit('SET_LOADING', false, { root: true });
          });
      } else {
        return axios.get('api/v1/supplier', { params: { paginate: 0 } }).then(response => {
          commit('setPlainSuppliers', response.data);
        });
      }
    },
    getSupplier({ commit }, payload) {
      commit('setGetSupplierLoading', true);
      return axios
        .get(`api/v1/supplier/${payload.id}`)
        .then(response => {
          commit('setSupplier', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setSupplier', {});
          }
        })
        .finally(() => {
          commit('setGetSupplierLoading', false);
        });
    }
  }
};
